import Vue from 'vue';

export default {
    find(parametros) {
        return Vue.axios.get("centro-de-costos/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    get(id) {
        return Vue.axios.get("centro-de-costos/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    update(parametros) {
        return Vue.axios.put("centro-de-costos", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    delete(id) {
        return Vue.axios.delete("centro-de-costos/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    store(parametros) {
        return Vue.axios.post("centro-de-costos", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}